import { render, staticRenderFns } from "./AlcedoLanding.vue?vue&type=template&id=e416174e&scoped=true"
import script from "./AlcedoLanding.vue?vue&type=script&lang=ts"
export * from "./AlcedoLanding.vue?vue&type=script&lang=ts"
import style0 from "./AlcedoLanding.vue?vue&type=style&index=0&id=e416174e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e416174e",
  null
  
)

export default component.exports